import { useGetMatchesGroupedByCompetitionQuery } from '@/store/api/sportsApi';

/**
 * Live match count per sport (keyed by lowercase API sport name) plus the total.
 * Same args as the Home in-play view, so all callers share one cached request.
 */
export const useInplayCounts = () => {
  const { data } = useGetMatchesGroupedByCompetitionQuery(
    { sortBy: 'time', inplay: true },
    { pollingInterval: 30000 }
  );

  const counts: Record<string, number> = {};
  Object.entries(data?.fixture ?? {}).forEach(([sport, competitions]) => {
    counts[sport.toLowerCase()] = Object.values(competitions).reduce(
      (sum, events) => sum + events.length,
      0
    );
  });
  const total = Object.values(counts).reduce((sum, n) => sum + n, 0);

  return { counts, total };
};
